import { apiGetAuth } from '@/utils/api'
import { API_LOG } from '@/utils/api-url'
import { notificationDanger } from '@/utils/notification'

const state = () => {
  return {
    list_log: { data: [] },
    isLoading: false
  }
}

const mutations = {
  SET_LIST_LOG (state, payload) {
    state.list_log = payload
  },
  SET_IS_LOADING (state, payload) {
    state.isLoading = payload
  }
}

const actions = {
  async getListLog (context) {
    try {
      const response = await apiGetAuth(API_LOG.SYNC_STATUS_SUPPORT)
      const responseData = response.data

      if (responseData && responseData.data === null) {
        responseData.data = []
      }

      context.commit('SET_LIST_LOG', responseData)
    } catch (error) {
      notificationDanger(error)
    }
  }
}

const getters = {
  list_log (state) {
    return state.list_log
  },
  isLoading (state) {
    return state.isLoading
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
